import React, { useState, useEffect, useRef } from "react";

import {
  getAvailableReportsHeading,
  EMPTY_DOWNLOAD_REPORT_CRITERIA,
} from "../../constants/ReportsConstant";
import { ResponsiveBox } from "../primitives";

import { withSidebar } from "../hoc/withSidebar";
import warningIcon from "../../assets/images/warning-icon.png";
import CommonLayout from "../custom/containers/CommonLayout";
import { useCustomHook } from "../custom/useCustomHook";
import { useTranslation } from "react-i18next";
import actions from "../../actions";
import { useSelector, useDispatch } from "react-redux";
import ErrorMessage from "../custom/containers/ErrorMessage";
import availableDocumentTypes from "../../actions/types/availableDocument.action.type";
import CommonContainerBox from "../custom/containers/CommonContainerBox";
import { FI, RoleType } from "../../constants/sharedConstants";
import { requiredFieldError, isBigFI } from "../../utils/helper";

const DownloadReports = (props) => {
  const { t } = useTranslation();
  const {
    location: { pathname },
  } = props;
  const dispatch = useDispatch();
  const downloadReportResultForWP = useSelector(
    (state) => state.availableDocumentReducer?.availableDocument
  );
  const downloadReportResult = useSelector(
    (state) => state.availableDocumentReducer?.downloadReportListData
  );
  const downloadReportErrorForWP = useSelector(
    (state) => state.availableDocumentReducer?.error
  );
  const downloadReportListError = useSelector(
    (state) => state.availableDocumentReducer?.downloadReportListError
  );

  const reportNames = useSelector(
    (state) => state.availableDocumentReducer?.reportNames
  );

  const reportListDropDown = useSelector(
    (state) => state.availableDocumentReducer?.reportListDropDown
  );
  const [downloadReportList, setDownloadReportList] = useState(null);
  const [dropdownReportListLoading, setDropdownReportListLoading] =
    useState(false);
  const [reportNameList, setReportNameList] = useState([]);
  const [showApiExceptionMessage, setShowApiExceptionMessage] = useState(false);
  const apiExceptionMessage = useSelector(
    (state) => state.availableDocumentReducer?.downloadReportError
  );
  const apiExceptionMessageDownloadDocument = useSelector(
    (state) => state.availableDocumentReducer?.downloadDocumentError
  );
  const [pageNumber, setPageNumber] = useState(0);
  const [rowPerPage, setRowPerPage] = useState(25);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [highlightError, setHighlightError] = useState({});
  const loginUser = useSelector((state) => state.loginUserReducer?.user);
  const roleId = loginUser?.role?.role_id;
  const fiNumber = useSelector((state) => state.fiReducer?.selectedFi || loginUser?.fiNumber);
  const isWebportalReport = (roleId == 1 || roleId == 2) && isBigFI(fiNumber);
  
  const [showSubscribingEntity, setShowSubscribingEntity] = useState(fiNumber == FI.TFX && RoleType.ERPADMIN.id == roleId ? 1 : 0);
  const subscribeEntities = useSelector( (state) => state.subscribingEntitiesReducer );
  const [subscribeEntityList, setSubscribeEntityList] = useState(null);
  
  const apiExceptionRef = useRef();
  const [searchResultException, setSearchResultException] = useState(null);

  useEffect(() => {
    dispatch({
      type: availableDocumentTypes.GET_AVAILABLE_REPORTS_SUCCESS,
      data: null,
    });
    const reqApiData = {
      start_off_set: 0,
      end_off_set: 25,
      start_date: "",
      end_date: "",
      reportName: "",
      fi_company_number: loginUser.fiCompanyNumber, // will be non-empty only for TFX (FI 88)
      languageCode: loginUser?.languageCode,
    };

    setDropdownReportListLoading(true);
    if (isWebportalReport) {
      dispatch( actions.availableDocumentActions.getReportsList( { ...reqApiData, biller_id: 0 } ) );
    } else {
      dispatch( actions.availableDocumentActions.getReportNames(reqApiData) );
    }

    if (fiNumber == FI.TFX)
      searchCriteria.fiCompanyNumber = loginUser.fiCompanyNumber;

    if (showSubscribingEntity > 0 && !(subscribeEntities.subscribingEntitiesList?.length > 0))
      dispatch(actions.userActions.getSubscribingEntitiesList(fiNumber));
  }, []);

  useEffect(() => {
    const downloadReportResponse =
      isWebportalReport
        ? downloadReportResultForWP
        : downloadReportResult;
    if (downloadReportResponse) {
      const updatedData = downloadReportResponse?.data?.map(
        (downloadReport, idx) => ({ ...downloadReport, id: idx })
      );
      setDownloadReportList(updatedData);
    }
  }, [downloadReportResult, downloadReportResultForWP]);

  useEffect(() => {
    let reportNameList = [];
    var isReturnsPortalLive = loginUser.commonConfig?.IS_RETURNS_PORTAL_LIVE === "Y";
    if (isWebportalReport) {
      if (reportListDropDown)
        reportNameList = reportListDropDown
              .filter(val => isReturnsPortalLive || val != "Daily Recalled and Rejected Payments Report")
              .map((val) => ({ label: val, value: val }));
    } else if (reportNames) {
      const uniqueReportName = Array.from(
        new Set(reportNames.map((a) => a.reportName.trim()))
      ).map((reportName) => 
        reportNames.find( (a) => a.reportName?.trim() === reportName )
      );
      if (isReturnsPortalLive) {
        reportNameList = uniqueReportName.map((r) => ({
            label: 
            r.reportName === "Daily Recalled and Rejected Payments Report"
              ? r.reportDescription
              :`${r.reportName} - ${r.reportDescription}`,
            value: r.reportName,
          })
        );
      } else {
        reportNameList = uniqueReportName
            .filter(r => r.reportName !== "Daily Recalled and Rejected Payments Report")
            .map(r => ({ label: `${r.reportName} - ${r.reportDescription}`, value: r.reportName }));
      }
    }
    reportNameList?.unshift({ label: "", value: "" });
    setDropdownReportListLoading(false);
    setReportNameList(reportNameList);
  }, [reportListDropDown, reportNames]);

  useEffect(() => {
    if (apiExceptionRef.current) {
      apiExceptionRef.current.focus();
    }
  }, [
    apiExceptionMessage && showApiExceptionMessage,
    validationErrors,
    searchResultException,
  ]);

  const extraInputValiation = (validationResult) => {
    // validationResult is an object:  { errors: [], highlightError: {} };
    if (showSubscribingEntity > 1 && searchCriteria.fiCompanyNumber === "") {
      validationResult.errors.push(requiredFieldError("erps.newuser.label.subscribingentityid"));
      validationResult.highlightError["subscribeEntityId"] = true;
    }
  };

  const pageName = pathname.split("/")[1];
  const hasButtonVisible = true;
  const date = new Date();
  const minDateVal = new Date(
    date.getFullYear(),
    date.getMonth() - 13,
    date.getDate()
  );
  const maxDateVal = new Date();
  const {
    isSearchValid,
    searchCriteria,
    searchResults,
    searchCriteriaChangeHandler,
    handleAvailableReportsSearch,
    resetAvailableReportsHandler,
    paginateAvailableReports,
    hasSearch,
  } = useCustomHook({
    tableResults: downloadReportList,
    tableHeadings: getAvailableReportsHeading(fileDownload, roleId),
    initialStates: { ...EMPTY_DOWNLOAD_REPORT_CRITERIA, isWebportalReport: isWebportalReport },
    roleId,
    loginUser,
    setPageNumber,
    setRowPerPage,
    setLoading,
    rowPerPage,
    pageNumber,
    setErrorMessage: setValidationErrors,
    errorMessage: validationErrors,
    setHighlightError,
    minDateValue: minDateVal,
    maxDateValue: maxDateVal,
    extraInputValiation
  });

  useEffect(() => {
    if (hasSearch) {
      const error = downloadReportErrorForWP || downloadReportListError;
      setSearchResultException(error);
    } else {
      setSearchResultException(null);
    }
  }, [downloadReportErrorForWP, downloadReportListError]);

  useEffect(() => {
    if (showSubscribingEntity > 0 && subscribeEntities.subscribingEntitiesList?.length > 0) {
      const data = subscribeEntities.subscribingEntitiesList.map( se => ({value: se.fiCompanyNumber, label: se.fiCompanyName}) );
      data.unshift({value: "", label: ""});
      setSubscribeEntityList(data);
    }
  }, [subscribeEntities.subscribingEntitiesList]);

  useEffect(() => {
    if (showSubscribingEntity > 0)
      setShowSubscribingEntity(searchCriteria.reportName === "Daily Recalled and Rejected Payments Report" ? 2 : 1);
  }, [searchCriteria.reportName]);

  const getReportPath = (reportDocData) => {
    return isWebportalReport
      ? reportDocData?.pdf_link || reportDocData?.csv_link
      : reportDocData?.reportPath || reportDocData?.reportPathCsv;
  };

  function fileDownload(reportDocData, fileFormat) {
    const reportPath = getReportPath(reportDocData);
    const pattern = /\\/;
    const updatedReportPath = pattern.test(reportPath.charAt(0))
      ? reportPath.slice(1)
      : reportPath;

    setShowApiExceptionMessage(false);
    dispatch(
      actions.availableDocumentActions.downloadReports(
        {
          ...reportDocData,
          reportPath: updatedReportPath,
          languageCode: loginUser?.languageCode,
          downloaded_file_format: fileFormat,
        },
        { setShowApiExceptionMessage }
      )
    );
  }

  return (
    <div role="main">
      <ResponsiveBox ml={3}>
        <ResponsiveBox sx={{ width: { xs: "100%", lg: "66.666%" }, maxWidth: "100%" }}>
          <ErrorMessage 
            error={
              apiExceptionMessage ||
              apiExceptionMessageDownloadDocument ||
              (validationErrors.length
                ? validationErrors
                : searchResultException)
            }
            errorRef={apiExceptionRef}
            mt={4}
          />
          {/* For Title update */}
          <CommonContainerBox title={t("erps.downloadreports.page.title")} />
          <CommonLayout
            pageTitle={t("erps.downloadreports.page.title")}
            pageSubHeading={t("erps.downloadreports.heading")}
            primaryButtonLabelV2={t("erps.common.button.reset")}
            secondaryButtonLabel={t("erps.common.button.search")}
            firstTextInputFieldLabel={t("erps.downloadreports.label.from")}
            firstTextInputFieldId="downloadreports__from"
            secondTextInputFieldLabel={t("erps.downloadreports.label.to")}
            secondTextInputFieldId="downloadreports__to"
            isEnable={false}
            pageName={pageName}
            warningIcon={warningIcon}
            searchResultLabel={t("erps.downloadreports.label.searchResult")}
            searchResultFoundLabel={t(
              "erps.downloadreports.label.searchResultFound"
            )}
            errorMssg={t("erps.downloadreports.filter.error.emptyinput")}
            searchNotStarted={t("erps.downloadreports.searchreport.notstarted")}
            startSearchHandler={handleAvailableReportsSearch} // ToDo - Update handler to Report
            searchCriteriaChangeHandler={searchCriteriaChangeHandler}
            resetHandler={resetAvailableReportsHandler} // ToDo - Update handler to Report
            isSearchValid={isSearchValid}
            searchCriteria={searchCriteria}
            initiateSearch={paginateAvailableReports} // ToDo - Update handler to Report
            searchResults={
              searchResults || {
                rows: downloadReportList || [],
                count: isWebportalReport ? downloadReportResultForWP?.count : downloadReportResult?.count,
                columns: getAvailableReportsHeading(fileDownload, isWebportalReport),
              }
            }
            labelLinkValue={["downloadReportId"]}
            actionType={{
              primaryButtonActionTypeV1: "hasDownloadReportAccess",
              firstTextInputFieldActionType: "hasFromTextField",
              secondTextInputFieldActionType: "hasToTextField",
              primaryButtonActionTypeV2: "hasResetBtn",
              secondaryButtonActionType: "hasSearchReportAccess",
            }}
            isDisabled={hasButtonVisible}
            sumOfColumnWidth="true"
            thirdTextInputFieldId="Report name"
            reportNameList={reportNameList}
            subscribeEntityList={showSubscribingEntity > 1 && subscribeEntityList}
            pageNumber={pageNumber}
            rowPerPage={rowPerPage}
            loading={loading}
            hasDropDownLoading={dropdownReportListLoading}
            highlightError={highlightError}
            minDateVal={minDateVal}
            maxDateVal={maxDateVal}
          />
        </ResponsiveBox>
      </ResponsiveBox>
    </div>
  );
};

export default withSidebar(DownloadReports);
